import { ExportColumn } from "@app/report-customization/build-reports/interfaces/exportColumns";
import { ReportType } from "@app/report-customization/build-reports/interfaces/reportTypeEnum";
import { BulkProjectTypeEnum } from "@app/shared/enums/bulkProjectTypeEnum";
import { JSX } from "react";

interface BulkTerminationProjectResponseModel {
  hasTerminations: boolean;
  isReadOnly: boolean;
  projectId: number;
  projectName: string;
  templateName: string;
  hasSuccessfulLatestRun: boolean;
  vaClaimsColumnEnabled: boolean;
  tricareClaimsColumnEnabled: boolean;
  shouldSkipTerminationTimeDistanceRecalc: boolean;
}

interface BulkCreateProviderTerminationsModel {
  //returned from the previous API call
  bulkProviderTerminationId: number;

  bulkProviderTerminationMethod: BulkProviderTerminationMethod;

  customProjectIds: number[];

  emailOnSuccess: boolean;

  exportName: string;

  formatType: string;

  includedReports?: IncludedReportsAndPresetIds;

  isDistinctServicingProviderReport: boolean;

  lineOfBusiness: string;

  projectType: BulkProjectTypeEnum;

  // from the comment field
  reasonDescription: string;

  reasonName: string;

  shouldSkipTerminationTimeDistanceRecalc: boolean;

  terminateByNpi: boolean;

  terminateByTin: boolean;

  terminateByAllLocations: boolean;

  terminateByAllSpecialties: boolean;
}

enum TerminationsWizardContextSteps {
  "SelectProjects",
  "ImportList",
  "Review",
  "ConfigureReport",
  "ColumnConfiguration",
}

interface TerminationsWizardStepProps {
  formIsValid: (flag: boolean) => void;
}

enum BulkProviderTerminationMethod {
  Unknown = "Unknown",
  Import = "Import",
  Ghost = "Ghost",
}

interface ImportBulkTerminationFileResponse {
  bulkProviderTerminationId: number;
  validRecordsCount: number;
  recordsInvalidByNpiCount: number;
  recordsInvalidByTinCount: number;
  recordsInvalidByNpiAndTinCount: number;
  recordsInvalidByNppesCount: number;
  invalidFormatNpis: string[];
  invalidFormatTins: string[];
  invalidNotFoundNpis: string[];
  uploadLimitationStatus?: number;
}

interface IncludedReports {
  projectDetailsTerminationOverview: boolean;
  serviceAreaSpecialtySummaryChangedGaps: boolean;
  serviceAreaSpecialtySummaryComparison: boolean;
  opportunitySpecialtySummaryChangedGaps: boolean;
  opportunitySpecialtySummaryComparison: boolean;
  terminationUploadFile: boolean;
  serviceAreaProviders: boolean;
  ghostTerminationList: boolean;
  opportunityProviders: boolean;
  includeReportMetadataSummary: boolean;
}

interface IncludedReportsAndPresetIds extends IncludedReports {
  projectDetailsTerminationOverviewReportCustomizationId?: number;
  serviceAreaSpecialtySummaryChangedGapsReportCustomizationId?: number;
  serviceAreaSpecialtySummaryComparisonReportCustomizationId?: number;
  opportunitySpecialtySummaryChangedGapsReportCustomizationId?: number;
  opportunitySpecialtySummaryComparisonReportCustomizationId?: number;
  terminationUploadFileReportCustomizationId?: number;
  serviceAreaProvidersReportCustomizationId?: number;
  ghostTerminationListReportCustomizationId?: number;
  opportunityProvidersReportCustomizationId?: number;
}

interface ITermRefinementOption {
  isAllLocations: boolean;
  isAllSpecialties: boolean;
  infoMessage: JSX.Element;
}

interface ColumnConfigurationReportSection {
  columnsEndpoint: () => Promise<ExportColumn[]>,
  key: keyof IncludedReports,
  reportType: ReportType,
  title: string,
}

export {
  BulkCreateProviderTerminationsModel,
  BulkProviderTerminationMethod,
  BulkTerminationProjectResponseModel,
  BulkProjectTypeEnum,
  ImportBulkTerminationFileResponse,
  IncludedReports,
  IncludedReportsAndPresetIds,
  ITermRefinementOption,
  TerminationsWizardContextSteps,
  TerminationsWizardStepProps,
  ColumnConfigurationReportSection,
};
